<template>
<modal :show="show">
    <div class="modal-header border-0">
        <h5 class="modal-title">{{title}}</h5>
        <button @click="close" type="button" class="close btn btn-round">
            <i class="icon icon-close"></i>
        </button>
    </div>

    <div class="modal-body p-4">
        <input type="file" multiple @change="fileChange" id="up" ref="file" />
        <span ref="fileError" class="invalid-feedback"></span>
    </div>

    <div class="modal-footer border-0">
        <button @click="clickDone" role="button" class="btn btn-white btn-sm" type="submit">
            Done
        </button>
    </div>

</modal>
</template>

<script>
import Modal from "@/../submodules/vue-base/components/Modal";
export default {

    name: "UploadModal",

    components: {
        Modal,
    },

    props: {
        title: "",
    },

    data() {
        return {
            show: false,
            loading: false,
            files: [],
            fileTooBig: false
        }
    },
    methods: {
        open() {
            this.show = true;
            this.files = [];
        },
        close() {
            this.show = false;
        },
        clickDone() {
            this.$emit("selected", this.files);
            this.show = false;
        },
        fileChange(fileEvent) {
            this.files = fileEvent.target.files;
        },
    },
}
</script>
